export default "__VITE_ASSET__CU1n8SQe__"